import { SystemViewModel } from '../models/system-view.model';

const ICON_COLORS = ['#2563eb', '#7c3aed', '#059669', '#d97706', '#dc2626', '#0891b2', '#4f46e5', '#0d9488'];

export function getAppIconColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return ICON_COLORS[Math.abs(hash) % ICON_COLORS.length];
}

export function getAppInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  return (name.slice(0, 2) || 'AP').toUpperCase();
}

export function extractHostname(url?: string): string {
  if (!url) {
    return '';
  }
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url.replace(/^https?:\/\//, '').split('/')[0];
  }
}

export function mapApiProjectToViewModel(
  apiItem: any,
  pinnedSystemIds: Set<string>,
  ownClientId: string
 ): SystemViewModel | null {
  if (apiItem.clientId === ownClientId) {
    return null;
  }

  return {
    id: apiItem.clientId,
    name: apiItem.name,
    description: apiItem.description || '',
    redirectUri: apiItem.redirectUri,
    homeRedirectUri: apiItem.homeRedirectUri,
    isPinned: (apiItem.isPinned ?? false) || pinnedSystemIds.has(apiItem.clientId),
    lastAccessTime: apiItem.lastAccessTime,
    groupId: apiItem.groupId ?? apiItem.group_id ?? null,
    groupName: apiItem.groupName || apiItem.group_name || '',
    iconColor: getAppIconColor(apiItem.name || ''),
    initials: getAppInitials(apiItem.name || ''),
    hostname: extractHostname(apiItem.homeRedirectUri),
    usageGuide: apiItem.usageGuide || '',
  };
}

export function formatLoginTime(value?: string | null): string {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return '';
  }
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function getRelativeTime(value?: string): string {
  if (!value) {
    return 'Chưa truy cập';
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return 'Không rõ thời gian';
  }
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 1) {
    return 'Vừa xong';
  }
  if (diffMinutes < 60) {
    return `${diffMinutes} phút trước`;
  }
  if (diffHours < 24) {
    return `${diffHours} giờ trước`;
  }
  if (diffDays === 1) {
    return '1 ngày trước';
  }
  return `${diffDays} ngày trước`;
}
